import { IClausePopupState } from '.';

export const initialState: IClausePopupState = {
  values: {
    clauseId: '',
    lineId: '',
    lineName: '',
    clauseName: '',
    clauseExternalCode: '',
    clauseStatus: '',
    clauseDescription: '',
  },
  errors: {
    clauseId: '',
    lineId: '',
    lineName: '',
    clauseName: '',
    clauseExternalCode: '',
    clauseStatus: '',
    clauseDescription: '',
  },
  touched: {
    clauseId: false,
    lineId: false,
    lineName: false,
    clauseName: false,
    clauseExternalCode: false,
    clauseStatus: false,
    clauseDescription: false,
  },
};
